import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=c29d0f9a&"
import script from "./PriceList.ts?vue&type=script&lang=js&"
export * from "./PriceList.ts?vue&type=script&lang=js&"
import style0 from "./PriceList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports